export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#060a1f]">
      <div className="text-center">
        <div className="inline-block h-10 w-10 animate-spin rounded-full border-4 border-blue-500/20 border-t-[#5ba4f5]" />
        <p className="mt-4 text-sm text-blue-200/40">Loading...</p>
      </div>
    </div>
  );
}
